<template>

  <div class="padded">
    <h3>Backhaul Customer Summary</h3></br />

    <pie-chart
    :data="chartSites"
    thousands=","
    legend="right"
    :colors="colours"
    :download="true" />

    <hr />

    <h4>Customers</h4>
    <el-table
       :data="subscribers"
       border
       stripe
       show-summary
       sum-text="Totals"
       :summary-method="summaryFormatter"
       style="width: 100%">

       <el-table-column prop="siteStatus"
        label="Site Status">
       </el-table-column>

       <el-table-column prop="subscriber"
        label="Customer">
       </el-table-column>

       <el-table-column prop="provider"
        label="Provider">
       </el-table-column>

       <el-table-column prop="backhaulType"
        label="Type">
       </el-table-column>

       <el-table-column prop="backhaulStatus"
        label="Type">
       </el-table-column>

       <el-table-column prop="sites"
       label="Sites"
        sortable
        align="right"
        :formatter="formatInt">
       </el-table-column>

       <el-table-column
          prop="entranceFee"
          label="Entrance Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>

       <el-table-column
          prop="rowFee"
          label="ROW Fee"
          sortable
          align="right"
          :formatter="formatNum">
       </el-table-column>
     </el-table>
    <hr />

  </div>
</template>

<script>

import {chartColors} from '@/components/Data'

import PostMixins from '@/mixins/PostMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [PostMixins, ElTableMixins, NumberMixins],

  methods: {
    subscriberData (data) {
      this.subscribers = data

      if (this.subscribers && this.subscribers.length > 0) {

        for (var i = 0; i < this.subscribers.length; i++) {
          let label = this.subscribers[i].siteStatus + ' (' + this.subscribers[i].provider + ': ' + this.subscribers[i].backhaulType + ' ' + this.subscribers[i].subscriber + ')'

          this.chartSites.push([label, Number(Number(this.subscribers[i].sites).toFixed(2))])
          this.chartEnt.push([label, Number(Number(this.subscribers[i].entranceFee).toFixed(2))])
          this.chartRow.push([label, Number(Number(this.subscribers[i].rowFee).toFixed(2))])
        }

      }
    },

    summaryFormatter (param) {
      return this.totalColumns(param, 'Totals', ['sites', 'subscribers'], ['entranceFee', 'rowFee'])
    }

  },

  data () {
    return {
      subscribers: [],
      chartSites: [],
      chartEnt: [],
      chartRow: [],
      colours: chartColors
    }
  },

  created () {
    this.fetchData('report/backhaul/subscribers' + (this.org() && this.org().id && this.org().category === 'Backhaul' ? '/' + this.org().id : ''), this.subscriberData, 'Backhaul Customers stats')
  }
}
</script>



// WEBPACK FOOTER //
// BackhaulSubscriberSummary.vue?9c9a0fdc